import { render, staticRenderFns } from "./comincia.vue?vue&type=template&id=4c59a5dd"
import script from "./comincia.vue?vue&type=script&lang=js"
export * from "./comincia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports